define('modules/form_editor/views/editor_custom_password',['require','exports','module','./editor_text','../../editor/models/editorstate','ldsh!../templates/editor_custom_password'],function(require,exports,module){
  "use strict";

  var EditorText = require("./editor_text"),
    EditorState = require("../../editor/models/editorstate");

  module.exports = EditorText.extend({
    template: require("ldsh!../templates/editor_custom_password"),

    helpers: function () {
      var model = this.model;
      return {
        confirmationChecked: model.get("confirmation") ? 'checked' : '',
        confirmationLabel: model.get("confirmationLabel") ||
          $.i18n.t("formEditor.passwordConfirmationLabelValue")
      };
    },

    events: {
      "change .js-placeholder": "updateModel",
      "change .js-confirmation": "updateModel",
      "change .js-confirmation-label": "updateModel",
      "change .js-confirmation-placeholder": "updateModel"
    },

    updateModel: function () {
      var confirmationDifferent = this.$(".js-confirmation-different-message").val(),
          confirmationDifferentMessage = this.model.get("confirmationDifferentMessage") ||
            $.i18n.t("formEditor.passwordConfirmationDifferentMessageValue");

      this.model.set({
        isPopup: EditorState.isCurrentStepPopup(),
        placeholder: this.$(".js-placeholder").val().trim(),
        confirmation: this.$(".js-confirmation").is(':checked'),
        confirmationLabel: this.$(".js-confirmation-label").val().trim(),
        confirmationPlaceholder: this.$(".js-confirmation-placeholder").val().trim(),
        confirmationDifferentMessage: confirmationDifferent ?
          confirmationDifferent.trim() :
          confirmationDifferentMessage
      });
    },

    onRender: function() {
      this.$el.i18n();
    }
  });
});

